module.exports = __webpack_public_path__ + "static/media/IRON3USD.1b4d87ce.png";